import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        paddingRight: 25
    },
    list: {
        marginTop: 20
    },
    contentItemList: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    textItemList: {
        fontSize: 15,
        color: '#2C2C2E',
        marginTop: 3,
        paddingLeft: 10,
        fontWeight: 'bold'
    },
    hrLine: {
        height: 0.5,
        width: '100%',
        position: 'relative',
        borderWidth: 0.8,
        marginTop: 10,
        marginBottom: 10,
        borderColor: "rgba(44, 44, 46, 0.5)",
    },
    contentItems: {
        flexDirection: 'row',
    }
});

export default styles;
